// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import prepareNestedString from 'helpers/prepareNestedString'

// take an object and dynamically assign a nested value
// this returns the original object, only overwriting the
// nested value which as indicated by path.
// necessary for creating error responses on the fly
// within <FieldArray /> components.
// example:
// obj = {}
// path = foo.bar
// value = 'Test'
// setNestedValueInObject (obj, path, value) ==> { foo: { bar: 'Test' } }
const setNestedValueInObject = (obj, path, value) => {
  let schema = obj
  path = prepareNestedString(path)
  const len = path.length
  for (let i = 0; i < len - 1; i++) {
    let elem = path[i]
    if (!schema[elem]) schema[elem] = {}
    schema = schema[elem]
  }
  schema[path[len - 1]] = value
  return obj
}

export default setNestedValueInObject
